import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Teile võivad huvi pakkuda ka

  <span style="color:#85c1dc;">**FI:**</span>
  Saatat olla kiinnostunut myös

  <span style="color:#85c1dc;">**RU:**</span>
  Вас также может заинтересовать
*/
/* @__NO_SIDE_EFFECTS__ */
const m1155 = msg(
  mf`Teile võivad huvi pakkuda ka`,
  mf`Saatat olla kiinnostunut myös`,
  mf`Вас также может заинтересовать`,
)

export { m1155 as 'w.module.tied_products_section.similar' }